import PATH_PAGE from '@/router/path';
import { RouteParams } from '@/router/type';
import { useNavigate, useParams } from 'react-router-dom';

const useParamWorkspaceId = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams<RouteParams>();
  if (!workspaceId) {
    navigate(PATH_PAGE.setting.workspaces.root, {
      replace: true,
    });
    return { workspaceId: '' };
  }
  return { workspaceId };
};

export default useParamWorkspaceId;
